import React from 'react'

export const DoneIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <mask id="mask0_6387_71719"  maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16">
            <rect width="16" height="16" fill="#D9D9D9"/>
        </mask>
        <g mask="url(#mask0_6387_71719)">
            <path d="M6.36641 11.9991L2.56641 8.19909L3.51641 7.24909L6.36641 10.0991L12.4831 3.98242L13.4331 4.93242L6.36641 11.9991Z" fill="#4BB543"/>
        </g>
    </svg>
  )
}
